export function getReturnLink(name: string, zipCode: string): string {
  return `/pages/returns?order_number=${name.replace(
    '#',
    ''
  )}&postcode=${zipCode}`
}

export function canArrangeReturn(status: string): boolean {
  return (
    status === 'In Transit' ||
    status === 'Delivered' ||
    status === 'Partial Delivery'
  )
}
